import {recallListUrlIfSeen} from "../../../shared/utils/listMemory";
import {DEFAULT_STATUS_FILTER, ORDER_STATUSES} from "./orderStatus";

/** @type {Set<string>} */
const KNOWN_STATUSES = new Set(ORDER_STATUSES.map((s) => s.code));

/**
 * What the orders list was showing, as the parameters that make the order
 * page's next/previous walk through the same orders: its statuses and its
 * search. (Not its sorting or page: the walk is by order number.)
 *
 * If the list was never opened in this tab there is nothing to follow, and the
 * walk goes through every order. If it was opened with its default view, that
 * is what it showed: the orders still going.
 *
 * @returns {{status?: string[], search?: string}}
 */
export const listFilterForNeighbors = () => {
    const url = recallListUrlIfSeen("/orders");
    if (!url) return {};

    const params = new URLSearchParams(url.split("?")[1] ?? "");
    const wanted = params.has("status") ? params.getAll("status") : DEFAULT_STATUS_FILTER;
    // `?status=` on its own is "nothing ticked": no filter. Unknown codes are dropped.
    const status = wanted.filter((code) => KNOWN_STATUSES.has(code));
    const search = params.get("search") ?? "";

    return {...(status.length ? {status} : {}), ...(search ? {search} : {})};
};
